// Ian - 2026-10-15 - Price match pop-up (snippets/ian-price-match.liquid).
// Opens a native <dialog> instead of sending the visitor to /pages/contact. The form inside
// submits normally so Shopify's hCaptcha spam check runs; Shopify then brings the visitor back
// to this product page (?contact_posted=true) and this script reopens the pop-up on the thanks
// message, or on the errors if something needs fixing.
(function () {
  if (window.__ianPriceMatch) return;
  window.__ianPriceMatch = true;

  function init() {
    var dialog = document.getElementById('IanPriceMatch');
    var form = document.getElementById('IanPriceMatchForm');
    if (!dialog || !form || typeof dialog.showModal !== 'function') return; // no dialog support: link falls back to /pages/contact

    var body = dialog.querySelector('[data-ian-pm-body]');
    var done = dialog.querySelector('[data-ian-pm-done]');
    var pageField = dialog.querySelector('[data-ian-pm-page]');
    var submit = form.querySelector('[type="submit"]');
    var opener = null;

    function show(view) {
      body.hidden = view === 'done';
      done.hidden = view !== 'done';
      document.documentElement.classList.add('ian-pm-open');
      if (!dialog.open) dialog.showModal();
      if (view === 'done') { done.focus(); return; }
      var first = form.querySelector('input:not([type="hidden"])');
      if (first) first.focus();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('ian-pm-open');
      if (opener && opener.focus) opener.focus();
    });

    // Click on the dimmed backdrop closes it.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    document.querySelectorAll('[data-ian-pm-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        opener = e.currentTarget;
        if (pageField) pageField.value = window.location.href.split('#')[0]; // includes the selected variant
        show('form');
      });
    });
    dialog.querySelectorAll('[data-ian-pm-close]').forEach(function (b) { b.addEventListener('click', close); });

    form.addEventListener('submit', function () {
      if (submit) submit.textContent = 'Sending...';
    });

    // Back from Shopify after sending: show the result.
    if (form.querySelector('[data-ian-pm-posted]')) {
      opener = document.querySelector('[data-ian-pm-open]');
      show('done');
      // Drop contact_posted from the address bar so a refresh doesn't reopen the thanks message.
      if (window.history && history.replaceState && window.URLSearchParams) {
        var params = new URLSearchParams(window.location.search);
        params.delete('contact_posted');
        var qs = params.toString();
        history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
      }
    } else if (form.querySelector('[data-ian-pm-errors]')) {
      opener = document.querySelector('[data-ian-pm-open]');
      show('form');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
